import React from 'react';
import classnames from 'classnames';
import './style.scss';

const divCount = 10;
const bsPrefix = 'loading-wrapper';

const Loading = ({ size = 'lg' }): JSX.Element => {
  const classes = classnames(bsPrefix, size && `${bsPrefix}-${size}`);
  return (
    <div className="loading-container">
      <div className={classes}>
        {Array.from({ length: divCount }, (val, key) => (
          <div key={key}></div>
        ))}
      </div>
    </div>
  );
};
export default Loading;
